export default __webpack_public_path__ + "d0a5e2a12b23234c557593a9723efe5d.png";